import axios from "axios";
import { BASE_URL } from "../utils/constants";
import { store } from "../redux/store";
import { logout } from "../redux/user/userSlice";

export const apiClient = axios.create({
  baseURL: BASE_URL,
});

// Interceptor de request: agrega el token automáticamente
apiClient.interceptors.request.use(
  (config) => {
    const token = store.getState().user.currentUser?.data?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Interceptor de response: maneja token expirado (401)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch(logout());
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);
